const cards = document.querySelectorAll('[data-national-person-card]');

if (cards.length > 0) {
	cards.forEach((card) => {
		const list = card.querySelector('[data-national-person-list]');
		const items = list.querySelectorAll('.national-card__item');
		const moreBtn = card.querySelector('[data-national-person-btn]');
		const moreBtnText = moreBtn.querySelector('.text');

		if (items.length === 3 && moreBtn) {
			moreBtn.style.display = 'none';
			return;
		}

		const toggleItemsVisibility = (showAll) => {
			items.forEach((item, index) => {
				if (index >= 3) {
					item.classList.toggle('hidden', !showAll);
				}
			});
			card.classList.toggle('open', showAll);
			if (moreBtnText) {
				moreBtnText.innerText = showAll ? 'Скрыть' : 'Подробнее';
			}
		};

		// Изначально скрываем элементы
		toggleItemsVisibility(false);

		// Обработчик клика на кнопке
		moreBtn.addEventListener('click', () => {
			const isOpen = card.classList.contains('open');
			toggleItemsVisibility(!isOpen);
		});
	});

}
